import { ApprovalVisual } from './approval.visual';
import {
  type UseApprovalCustomFieldsInput,
  useApprovalCustomFields,
} from './useApprovalCustomFields';

export type ApprovalProp = UseApprovalCustomFieldsInput & {
  stepLoading: boolean;
};

export const Approval = ({
  options,
  onNext,
  stepLoading,
  objectId,
  objectType,
}: ApprovalProp) => {
  const {
    approvalData,
    setApprovalData,
    activeCustomFields,
    derivedCustomFields,
    loading,
    saveCustomFieldsAndContinue,
  } = useApprovalCustomFields({ options, onNext, objectId, objectType });

  return (
    <ApprovalVisual
      options={options}
      continueFunc={saveCustomFieldsAndContinue}
      loading={stepLoading || loading}
      approvalData={approvalData}
      updateApproval={setApprovalData}
      activeCustomFields={activeCustomFields}
      derivedCustomFields={derivedCustomFields}
    />
  );
};

export default Approval;
